<template>
  <v-container>
    <h2>User Data</h2>
    <v-row>
      <v-col md="6">
        <v-text-field
          hide-details
          label="Find a user"
          prepend-icon="mdi-magnify"
          single-line
          v-model="search_string"
        ></v-text-field>
      </v-col>
      <v-col md="6">
        <v-btn class="mr-1 pl-2 pr-2" color="primary" outlined @click="getUsersFromFirebase">
          <v-icon>mdi-firebase</v-icon>
          Search Firebase
        </v-btn>
        <v-btn class="mr-1 pl-2 pr-2" color="primary" outlined @click="getUsersFromDatabase">
          <v-icon>mdi-database</v-icon>
          Search Database
        </v-btn>
        <v-btn class="mr-1 pl-2 pr-2" color="primary" @click="getUsersFromAll">
          <v-icon>mdi-magnify</v-icon>
          Search Both
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col md="6">
        <v-card class="grey lighten-2">
          <v-card-title><v-icon>mdi-firebase</v-icon>Firebase</v-card-title>
        </v-card>
        <v-expansion-panels>
          <v-expansion-panel
            v-for="fb_user in firebase_users"
            :key="fb_user.user_id"
          >
            <v-expansion-panel-header>
              <template v-slot:default="{ open }">
                <v-fade-transition leave-absolute>
                  <v-row v-if="open" key="0">
                    <v-col class="title">
                      <span class="font-italic text--secondary">{{
                        fb_user.user_id
                      }}</span>
                    </v-col>
                  </v-row>
                  <v-row no-gutters v-else key="1">
                    <v-col cols="4">{{ fb_user.full_name }}</v-col>
                    <v-col cols="8" class="text--secondary">
                      {{ fb_user.email }}
                    </v-col>
                  </v-row>
                </v-fade-transition>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    readonly
                    label="Name"
                    v-model="fb_user.full_name"
                  ></v-text-field>
                </v-col>
                <v-col md="6">
                  <v-text-field
                    readonly
                    label="Email"
                    v-model="fb_user.email"
                  ></v-text-field>
                </v-col>
                <v-col md="6">
                  <v-text-field
                    readonly
                    label="Group ID"
                    v-model="fb_user.group_id"
                  ></v-text-field>
                </v-col>
                <v-col md="6">
                  <v-text-field
                    readonly
                    label="Company ID"
                    v-model="fb_user.company_id"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-spacer></v-spacer>
                <v-col md="3">
                  <v-btn
                    block
                    color="error"
                    @click="
                    confirmResetFR('fb', fb_user.user_id, fb_user.full_name, fb_user.company_id)
                    "
                  >
                    <v-icon left dark>mdi-refresh</v-icon>Reset Face Record
                  </v-btn>
                </v-col>
                <v-col md="3" offset="6">
                  <v-btn
                    block
                    color="error"
                    @click="
                      confirmDelete('fb', fb_user.user_id, fb_user.full_name)
                    "
                  >
                    <v-icon left dark>mdi-delete</v-icon>Delete
                  </v-btn>
                </v-col>
                <!-- <v-col md="3">
                  <v-btn block color="success">
                    <v-icon left dark>mdi-floppy</v-icon>Save
                  </v-btn>
                </v-col> -->
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
      <v-col md="6">
        <v-card class="grey lighten-2">
          <v-card-title><v-icon>mdi-database</v-icon>CloudSQL</v-card-title>
        </v-card>
        <v-expansion-panels>
          <v-expansion-panel
            v-for="db_user in database_users"
            :key="db_user.id"
          >
            <v-expansion-panel-header>
              <template v-slot:default="{ open }">
                <v-fade-transition leave-absolute>
                  <v-row v-if="open" key="0">
                    <v-col class="title">
                      <span class="font-italic text--secondary">{{
                        db_user.id
                      }}</span>
                    </v-col>
                  </v-row>
                  <v-row no-gutters v-else key="1">
                    <v-col cols="4">{{ db_user.full_name }}</v-col>
                    <v-col cols="8" class="text--secondary">
                      {{ db_user.email }}
                    </v-col>
                  </v-row>
                </v-fade-transition>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    readonly
                    label="Name"
                    v-model="db_user.full_name"
                  ></v-text-field>
                </v-col>
                <v-col md="6">
                  <v-text-field
                    readonly
                    label="Email"
                    v-model="db_user.email"
                  ></v-text-field>
                </v-col>
                <v-col md="6">
                  <v-text-field
                    readonly
                    label="Employee Code"
                    v-model="db_user.employee_code"
                  ></v-text-field>
                </v-col>
                <v-col md="6">
                  <v-text-field
                    readonly
                    label="Job Position"
                    v-model="db_user.job_position"
                  ></v-text-field>
                </v-col>
                <v-col md="6">
                  <v-text-field
                    readonly
                    label="Group ID"
                    v-model="db_user.groupId"
                  ></v-text-field>
                </v-col>
                <v-col md="6">
                  <v-text-field
                    readonly
                    label="Company ID"
                    v-model="db_user.company_id"
                  ></v-text-field>
                </v-col>
                <v-col md="6" class="pt-0 mb-3">
                  <v-btn
                    small
                    depressed
                    outlined
                    v-show="db_user.is_join_company"
                    color="success"
                  >
                    <v-icon v-show="db_user.is_join_company">mdi-check</v-icon>
                    Joined
                  </v-btn>
                  <v-btn
                    small
                    depressed
                    outlined
                    disabled
                    v-show="!db_user.is_join_company"
                    color="error"
                  >
                    <v-icon v-show="!db_user.is_join_company">mdi-close</v-icon>
                    Not Joined
                  </v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-spacer></v-spacer>
                 <v-col md="3">
                  <v-btn
                    block
                    color="error"
                    @click="
                    confirmResetFR('db', db_user.id, db_user.full_name)
                    "
                  >
                    <v-icon left dark>mdi-refresh</v-icon>Reset Face Record
                  </v-btn>
                </v-col>
                <v-col md="3" offset="6">
                  <v-btn
                    block
                    color="error"
                    @click="confirmDelete('db', db_user.id, db_user.full_name)"
                  >
                    <v-icon left dark>mdi-delete</v-icon>Delete
                  </v-btn>
                </v-col>
                <!-- <v-col md="3">
                  <v-btn block color="success">
                    <v-icon left dark>mdi-floppy</v-icon>Save
                  </v-btn>
                </v-col> -->
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
    <v-dialog v-model="delete_dialog" max-width="380">
      <v-card>
        <v-card-title class="headline">Delete this User?</v-card-title>
        <v-card-text
          >You have selected the user <b>{{ selected_user.name }}</b> with the
          ID <b>{{ selected_user.id }}</b> to be deleted.</v-card-text
        >
        <v-card-text>Are you sure you would like to do this?</v-card-text>
        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="delete_dialog = false"
            >Cancel</v-btn
          >
          <v-btn color="error" @click="deleteUser(selected_user)">Delete</v-btn>
          <!-- <v-btn color="error" @click="showAlert">Delete</v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="reset_fr_dialog" max-width="380">
      <v-card>
        <v-card-title class="headline">Reset this User Face Record?</v-card-title>
        <v-card-text
          >You have selected the user <b>{{ selected_user.name }}</b> with the
          ID <b>{{ selected_user.id }}</b> face record to be reset.</v-card-text
        >
        <v-card-text>Are you sure you would like to do this?</v-card-text>
        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="reset_fr_dialog = false"
            >Cancel</v-btn
          >
          <v-btn color="error" @click="resetFR(selected_user)" :loading="loadingButton">Reset</v-btn>
          <!-- <v-btn color="error" @click="showAlert">Delete</v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar top v-model="alert" multi-line :color="alert_mode">
      {{ alert_text }}
      <v-btn text @click="alert = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-container>
</template>
<script>
import firebase from "firebase";
import ENV from './../../store/modules/environtment'
export default {
  name: "user-data",
  data() {
    return {
      baseUrl: this.$store.state.baseUrl,
      search_string: "",
      firebase_users: [],
      database_users: [],
      reset_fr_dialog: false,
      delete_dialog: false,
      loadingButton: false,
      selected_user: {},
      alert: false,
      alert_text: "",
      alert_mode: "",
    };
  },
  methods: {
    showAlert(mode, text) {
      this.alert_mode = mode;
      this.alert_text = text;
      this.loadingButton = false;
      this.delete_dialog = false;
      this.reset_fr_dialog = false;
      this.alert = true;
      this.getUsersFromAll();
    },
    confirmResetFR(mode, user_id, user_name, company_id) {
      this.reset_fr_dialog = true;
      this.loadingButton = false;
      this.selected_user = {
        mode: mode,
        id: user_id,
        name: user_name,
        company: company_id
      };
    },
    handleReset(error){
      switch(error) {
        case 'subject id was not found':
          return 'This user has no face record, please enroll.'
        case 'subject id with face id was not found':
          return 'This user id with face id was not found.'
        case 'gallery name not found':
          return 'Gallery not found.'
        default:
          return(error)
      }
    },
    confirmDelete(mode, user_id, user_name) {
      this.delete_dialog = true;
      this.loadingButton = false;
      this.selected_user = {
        mode: mode,
        id: user_id,
        name: user_name,
      };
    },
    async resetFR(user){
      const company = user.company.substring(0, 24);
      const id = user.id.substring(0, 28);
      this.loadingButton = true;
      const result = await this.$store.dispatch('deleteUserFace', {userId: id, companyId: company})
      this.loadingButton = false;
      if (result) {
        const text = `Face Record of User ${user.name} with the ID ${user.id} has been successfully reset`
        this.showAlert("success", text);
      }
    },
    async deleteUser(user) {
      if (user.mode === "fb") {
        firebase
          .firestore()
          .collection(ENV.firebase.user)
          .doc(user.id)
          .delete()
          .then(() => {
            const text =
              "User " +
              user.name +
              " with the ID" +
              user.id +
              " has been successfully deleted from Firebase!";
            this.showAlert("success", text);
          })
          .catch((error) => {
            this.showAlert("error", error);
          });
      } else if (user.mode === "db") {
        const result = await this.$store.dispatch('deleteUser', {id: user.id})
        if (result) {
          const text = `User ${user.name} with the ID ${user.id} has been successfully deleted from Database!`
          this.showAlert("success", text);
        }
      } else {
        const text = "User not recognized";
        this.showAlert("error", text);
      }
    },
    getUsersFromFirebase() {
      this.firebase_users = [];
      firebase
        .firestore()
        .collection(ENV.firebase.user)
        .orderBy("email")
        .startAt(this.search_string)
        .endAt(this.search_string + "\uf8ff")
        .get()
        .then((document) => {
          document.forEach((doc) => {
            const user = doc.data();
            this.firebase_users.push(user);
          });
        });
    },
    async getUsersFromDatabase() {
      this.database_users = await this.$store.dispatch('getUserByEmailOrUsername', {word: this.search_string})
    },
    async getUsersFromAll() {
      await this.getUsersFromFirebase();
      await this.getUsersFromDatabase();
    },
  },
};
</script>
<style>
.input-group--disabled.checkbox .input-group__input {
  color: #000 !important;
}

.input-group--disabled.input-group--select label {
  color: #000 !important;
}
</style>
